import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiModelCreationFailedAction = {
	type: 'AI_MODEL_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiModelCreationFailedAction => ({
	type: 'AI_MODEL_CREATION_FAILED',
	payload,
});
